module.exports = __webpack_public_path__ + "static/postmark-11bfadadadf65e303a7aa79b3b5a69b9.png";